<template>
  <div class="chat-window mr-sm-3">
    <div class="chat-overlap"></div>
    <v-container class="fill-height pa-0">
      <v-row class="no-gutters elevation-4">
        <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
          <v-responsive
            class="overflow-y-hidden fill-height"
            :style="{
              height: $vuetify.breakpoint.smAndUp ? '450px' : '90vh',
              maxHeight: '90vh'
            }"
          >
            <v-card
              flat
              class="d-flex flex-column fill-height rounded-0"
              :width="$vuetify.breakpoint.smAndUp ? '320px' : '100vw'"
              v-if="friend"
            >
              <v-card-title class="py-md-1 py-3 chat-box-title">
                <router-link
                  :to="{
                    name: 'profilePerson',
                    params: { key: friend.user.id }
                  }"
                >
                  <AvatarComponent
                    size="36"
                    :url="friend.user.picture"
                  />
                  <span class="ml-3 subtitle-1 black--text font-weight-medium">{{ friend.user.name }}</span>
                </router-link>
                <div class="ml-auto">
                  <v-btn v-if="false" icon @click="$parent.$refs.videoCall.call(friendId)">
                    <v-icon color="#BDBDBD" size="18">far fa-video</v-icon>
                  </v-btn>
                  <v-btn icon @click="hideChatBox">
                    <v-icon color="#BDBDBD" size="18">far fa-minus</v-icon>
                  </v-btn>
                  <v-btn icon @click="closeChatBox">
                    <v-icon color="#BDBDBD" size="18">far fa-xmark</v-icon>
                  </v-btn>
                </div>
              </v-card-title>
              <v-divider />
              <ChatConfirm
                :friend="friend"
                v-if="isFriendPending"
              />
              <v-card-text
                class="flex-shrink-1 overflow-y-auto"
                v-else-if="isFriendRequested"
                v-translate
                :key="isFriendRequested"
              >
                Your friend request is sent, please wait for confirmation from this user
              </v-card-text>
              <template v-else>
                <v-card-text
                  class="flex-grow-1 overflow-y-auto pb-2 pr-md-0"
                  ref="chatContent"
                  v-scroll.self="handleDebouncedScroll"
                  :class="{forceBottomMsg}"
                >
                  <div
                    class="divider"
                    v-if="loadMoreTop && !noMoreMessage"
                  >
                    <span class="divider-text">
                      <translate>Loading message, please wait ...</translate>
                    </span>
                  </div>
                  <p
                    v-if="noMoreMessage
                          && allMessages.length == 0
                          && !isFriendBlocking"
                    v-translate
                    :key="isFriendRequested"
                  >
                    Congrats !! You 2 can now talk to each other and plan a great game, BGC wish you luck to both of you !
                  </p>
                  <div
                    class="d-flex"
                    :class="[
                      message.me ? 'flex-row-reverse': '',
                      'msgIndex-' + i
                    ]"
                    v-for="(message, i) in allMessages"
                  >
                    <AvatarComponent
                      size="36"
                      v-if="!message.me"
                      :url="friend.user.picture"
                    />
                    <v-hover
                      v-slot="{ hover }"
                      open-delay="200"
                    >
                      <div class="chip-wrapper" :class="message.me ? 'text-right' : ''">
                        <v-chip
                          v-if="message.delete === MESSAGE_DELETE_BOTH"
                          :color="'grey lighten-2 grey--text'"
                          dark label class="px-2 py-2 mb-2 mx-md-3 ml-2 chatTime"
                          :class="[
                            message.me ? 'chatTimeLeft text-left' : '',
                            message.hideTime ? '' : 'pb-4',
                          ]"
                          outlined
                        >
                          <span class="font-italic deleteText">
                            {{ message.me ? $gettext('You') : friend.user.name}} <translate>deleted this message</translate>
                          </span>
                          <span v-if="!message.hideTime" class="ml-2 chatText"
                            >{{ message.time | ago }}
                          </span>
                        </v-chip>
                        <v-chip
                          v-else-if="message.blocked"
                          color="grey lighten-2"
                          dark label class="px-2 py-2 mb-2 mx-md-3 ml-2 chatTime"
                          :class="[
                            message.me ? 'chatTimeLeft' : '',
                            message.hideTime ? '' : 'pb-4',
                          ]"
                          outlined
                        >
                          <span>
                            <span class="black--text" v-html="message.content"></span><br>
                            <v-icon
                              x-small
                              color="red lighten-2"
                            >fas fa-exclamation</v-icon>&nbsp;
                            <translate
                              class="font-italic grey--text lighten-2"
                            >message blocked</translate>
                          </span>
                          <span v-if="!message.hideTime" class="ml-2 chatText"
                            >{{ message.time | ago }}
                          </span>
                        </v-chip>
                        <v-chip
                          v-else
                          :color="message.me
                                  ? 'primary'
                                  : 'grey lighten-4 black--text'"
                          dark label class="px-2 py-2 mb-2 mx-md-3 ml-2 chatTime"
                          :class="[
                            message.me ? 'chatTimeLeft' : '',
                            message.hideTime ? '' : 'pb-4',
                          ]"
                        >
                          <span v-html="message.content"></span>
                          <span v-if="!message.hideTime" class="ml-2 chatText"
                            >{{ message.time | ago }}
                          </span>
                        </v-chip>
                        <ChatMenuMessage
                          v-show="hover
                          && message.blockId
                          && message.delete !== MESSAGE_DELETE_BOTH"
                          :message="message"
                          :messageRaw="oldMessages[message.key]"
                          :friendId="friendId"
                          @deleteMessage="handleDeleteMessage"
                        />
                      </div>
                    </v-hover>
                  </div>
                  <ChatUnblock
                    :friend="friend"
                    v-if="isFriendBlocking"
                  />
                </v-card-text>
                <v-card-text
                  v-if="!isFriendBlocking"
                  class="flex-shrink-1 pa-md-1 py-4">
                  <v-textarea
                    v-model="messageContent"
                    :placeholder="$gettext('Write a reply...')"
                    no-details rounded dense filled auto-grow
                    append-icon="fas fa-paper-plane"
                    @keydown.enter="onSend($event)"
                    @click:append="onSend"
                    @focus="onChatInputFocus"
                    @blur="onChatInputBlur"
                    hide-details
                    background-color="#F2F2F2"
                    :rows="1"
                  />
                </v-card-text>
              </template>
            </v-card>
          </v-responsive>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChatService from "@/services/ChatService";
import ChatConfirm from "@/components/Chat/ChatConfirm";
import ChatUnblock from "@/components/Chat/ChatUnblock";
import ChatMenuMessage from "@/components/Chat/ChatMenuMessage";
import { debounce } from "@/utils/helper";
export default {
  props: {
    friendId: {type: Number, default: null},
    isTabActive: {type: Boolean, default: false}
  },
  components: {
    ChatConfirm,
    ChatUnblock,
    ChatMenuMessage
  },
  data() {
    return {
      messageContent: null,
      friend: null,
      loadMoreTop: false,
      scrollTimeOut: null,
      loadingBlock: false,
      oldestBlockIndex: 1,
      noMoreMessage: false,
      oldMessages: {},
      newMessages: {},
      forceBottomMsg: false,
      isMobile: false
    }
  },
  computed: {
    isAdmin() {
      const user = this.$store.state.auth.user;
      return user.subRoles && user.subRoles.indexOf('Administrator') !== -1
    },
    friends() {
      return this.$store.state.chat.friends;
    },
    isFriendPending() {
      return this.friend.status == FRIEND_STATUS_PENDING
    },
    isFriendRequested() {
      return this.friend.status == FRIEND_STATUS_REQUESTED
    },
    isFriendBlocking() {
      return this.friend.status == FRIEND_STATUS_BLOCKING
    },
    allMessages() {
      let messages = Object.assign(
                        [],
                        Object
                        .values(this.oldMessages)
                        .concat(
                          Object
                          .values(this.newMessages)
                        )
                      )

      messages.forEach((message, index) => {
        let hideTime = false;
        if (messages[index + 1]) {
          const nextMessage = messages[index + 1];
          if (
            message[MESSAGE_OWNER_INDEX] === nextMessage[MESSAGE_OWNER_INDEX] &&
            nextMessage[MESSAGE_TIME_INDEX] - message.[MESSAGE_TIME_INDEX] < 60000
          ) {
            hideTime = true;
          }
        }
        messages[index] = {
          me: message[MESSAGE_OWNER_INDEX] === 'me',
          time: message[MESSAGE_TIME_INDEX],
          content: message[MESSAGE_CONTENT_INDEX].trim().replace(/(?:\r\n|\r|\n)/g, "<br/>"),
          hideTime,
          'delete': message[MESSAGE_DELETE_INDEX],
          blockId: message[MESSAGE_BLOCKID_INDEX] || 0,
          key: this.key(message),
          blocked: message[MESSAGE_BLOCKID_INDEX] === MESSAGE_BLOCKED
        }
      })
      messages.sort(function (a, b) {
        return a.time - b.time;
      });
      return messages.filter(
        message => message.delete !== MESSAGE_DELETE_ME
      );
    },
    conversation() {
      return this.$store.state.chat.conversationMap[this.friendId]
    }
  },
  watch: {
    friends: {
      handler(value) {
        const friendState = this.findFriendState()
        if(!friendState) {
          this.hideChatBox();
          this.friend = null;

        }
        if(this.friend.status !== friendState.status) {
          this.friend = Object.assign({}, friendState)
        }
      },
      deep: true
    },
    newMessages: debounce(async function (value) {
      if (value.length == 0) return
      const myMessages = Object.values(value).filter(message => message[MESSAGE_OWNER_INDEX] === 'me')
      if (myMessages.length == 0) return
      const pushingMessages = Object.assign([], myMessages).map(message => [
        message[MESSAGE_TIME_INDEX],
        message[MESSAGE_CONTENT_INDEX]
      ])
      const result = await ChatService.pushMessage({
        partner: this.friendId,
        messages: pushingMessages
      });
      this.$store.dispatch('chat/getFriends')
      if(result.blockId) {
        const toBeResendMessages = []
        const updatedMessages = []
        myMessages.forEach((message, index) => {
          const isPushed = result.messageTimeList.indexOf(message[MESSAGE_TIME_INDEX]) !== -1;
          if(isPushed) {
            toBeResendMessages.push([
              'partner',
              message[MESSAGE_TIME_INDEX],
              message[MESSAGE_CONTENT_INDEX],
              message[MESSAGE_DELETE_INDEX],
              result.blockId
            ])
            updatedMessages.push([...message, result.blockId])
          }
        })
        if(updatedMessages.length > 0) {
          this.updateNewMessages(updatedMessages)
          this.$store.state.toggle.ChatFixedBottom.sendData({
            type: 'updateMessage',
            payload: {
              friendId: this.$store.state.auth.userId,
              messages: toBeResendMessages
            }
          }, this.friendId)
          this.$store.commit('chat/commitMessage', {
            friendId: this.friendId,
            messages: updatedMessages
          })
        }
      } else if(result.error) {
        if(result.error.message == 'friend blocked') {
          const updatedMessages = []
          myMessages.forEach((message, index) => {
            const isInArray = pushingMessages.find(pM => pM[0] === message[MESSAGE_TIME_INDEX]);
            if(isInArray) {
              updatedMessages.push([...message, MESSAGE_BLOCKED])
            }
          })
          if(updatedMessages.length > 0) {
            this.updateNewMessages(updatedMessages)
          }
        }
      }
    }, 1500),
    conversation() {
      if(this.oldestBlockIndex == 1) return
      let shouldScrollBottom = false;
      this.conversation.forEach(message => {
        if(!message) return;
        const key = this.key(message)
        if(message[MESSAGE_BLOCKID_INDEX]) {
          if(this.oldMessages.hasOwnProperty(key)) {
            const oldMessage = this.oldMessages[key];
            if(oldMessage[MESSAGE_DELETE_INDEX] === message[MESSAGE_DELETE_INDEX]) return
            this.$set(this.oldMessages, key, message)
            return
          }
          shouldScrollBottom = true
          this.$set(this.oldMessages, key, message)
        } else {

        }
      })
      if(shouldScrollBottom) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    }
  },
  mounted() {
    this.scrollToBottom();
    const friendState = this.findFriendState()
    if(!friendState) return
    this.friend = Object.assign({}, friendState)
    this.loadBlock();
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true })
    const elem = document.getElementById("app");
    elem.setAttribute("style","touch-action: none; -ms-touch-action: none; overflow: hidden;");
    document.documentElement.classList.add("chatbox-open");
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600;
    },
    findFriendState() {
      const friends = this.friends.filter(friend => friend.user.id === this.friendId)
      if(!friends) return null
      const notDeniedFriend = friends.find(friend => friend.status !== FRIEND_STATUS_DENIED)
      if(notDeniedFriend) return notDeniedFriend
      return friends[0]
    },
    updateNewMessages(updatedMessages) {
      updatedMessages.forEach(updatedMessage => {
        const key = this.key(updatedMessage)
        if(this.newMessages[key]) {
          this.$delete(this.newMessages, key, updatedMessage)
          this.$set(this.oldMessages, key, updatedMessage)
        }
      })
    },
    onSend(event) {
      if (event.shiftKey === true) return;
      if (this.messageContent.trim() === '') return;
      event.stopPropagation();
      event.preventDefault();
      const message = [
        'me',
        Date.now(),
        this.messageContent,
        MESSAGE_DELETE_NONE
      ]
      this.$set(this.newMessages, this.key(message), message)
      this.$nextTick(() => {
        this.scrollToBottom();
      });

      this.messageContent = ''
      const theirMessage = Object.assign([], message);
      theirMessage[MESSAGE_OWNER_INDEX] = 'partner'
      this.$store.state.toggle.ChatFixedBottom.sendData({
        type: 'message',
        payload: {
          friendId: this.$store.state.auth.userId,
          message: theirMessage
        }
      }, this.friendId)
      return false
    },
    scrollToBottom() {
      const chatContent = this.$refs.chatContent;
      if (chatContent) chatContent.scrollTop = chatContent.scrollHeight;
    },
    async loadBlock(keepCurrentScroll = false) {
      this.loadingBlock = true;
      const chatContent = this.$refs.chatContent;
      let currentScrollFromBottom = 0;
      if (chatContent) {
        currentScrollFromBottom =
          chatContent.scrollHeight - chatContent.scrollTop;
      }
      let result = await ChatService.loadMoreOld(this.friendId, this.oldestBlockIndex);
      if (!result.blockId) {
        this.noMoreMessage = true;
        this.loadMoreTop = false;
        this.loadingBlock = false;
        return;
      }

      if (result.noMoreBlock === true) {
        this.noMoreMessage = true;
        this.loadMoreTop = false;
      }
      result.messages.forEach(message => {
        this.$set(this.oldMessages, this.key(message), [...message, result.blockId])
      })
      this.loadingBlock = false;
      this.oldestBlockIndex++;
      const _this = this;
      if (keepCurrentScroll) {
        this.$nextTick(() => {
          if (chatContent) {
            chatContent.scrollTop =
              chatContent.scrollHeight - currentScrollFromBottom;
          }
        });
      } else {
        this.$store.commit('chat/flushMessageFromLocal', this.friendId)
        this.$nextTick(() => {
          _this.scrollToBottom();
          if (!result.noMoreBlock) {
            _this.loadMoreTop = true
          }
          if(!_this.noMoreMessage
              && _this.$refs.chatContent.scrollHeight < 440
          ) {
            _this.checkScrollAndLoadBlock(false)
          }
        });
      }

    },
    handleDebouncedScroll() {
      clearTimeout(this.scrollTimeOut)
      const _this = this
      this.scrollTimeOut = setTimeout(() => {
        _this.checkScrollAndLoadBlock()
      }, 1000)
    },
    checkScrollAndLoadBlock(keepCurrentScroll = true) {
      const chatContent = this.$refs.chatContent;
      if(chatContent.scrollTop < 100
        && this.loadMoreTop
        && !this.noMoreMessage
        && !this.loadingBlock
      ) {
        this.loadBlock(keepCurrentScroll)
      }
    },
    hideChatBox() {
      this.$store.dispatch('chat/hideChatBox', this.friendId);
    },
    closeChatBox() {
      this.$store.dispatch('chat/removeActiveChat', this.friendId);
    },
    key(message) {
      return message[MESSAGE_OWNER_INDEX] + message[MESSAGE_TIME_INDEX]
    },
    onChatInputFocus() {
      if(this.isMobile
        || ( window.cordova
              && window.cordova.platformId.toLowerCase() == 'ios'
            )
      ) {
        this.forceBottomMsg = true
      }
    },
    onChatInputBlur() {
      if(this.isMobile
        || ( window.cordova
              && window.cordova.platformId.toLowerCase() == 'ios'
            )
      ) {
        this.forceBottomMsg = false
      }
    },
    handleDeleteMessage(message) {
      const key = this.key(message)
      if(this.oldMessages.hasOwnProperty(key)) {
        const oldMessage = this.oldMessages[key];
        if(oldMessage[MESSAGE_DELETE_INDEX] === message[MESSAGE_DELETE_INDEX]) return
        this.$set(this.oldMessages, key, message)
      }
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return;
    window.removeEventListener('resize', this.onResize, { passive: true })
    const elem = document.getElementById("app");
    elem.setAttribute("style","touch-action: auto; -ms-touch-action: auto; overflow: auto;");
    document.documentElement.classList.remove("chatbox-open");
  },
};
</script>
<style lang="scss">
.chatTime {
  height: auto !important;
  min-width: 100px;
  max-width: 90% !important;
  .chatText {
    font-size: 0.6rem;
    position: absolute;
    left: 0px;
    bottom: 0px;
    color: #999;
    white-space: nowrap;
  }
  .v-chip__content {
    white-space: initial;
  }
}
.chatTimeLeft {
  .chatText {
    color: #eee;
  }
}
.chip-wrapper {
  position:relative;
  > .chatTime {
    min-width: 123px;
    .deleteText {
      min-width: 190px;
    }
  }
}
</style>